export const createGetAllContentWritingStyleListRequest = (disableLoading = false) => {
  return {
    url: "/content_writing_styles",
    method: "GET",
    disableLoading,
  };
};

export const createGetContentWritingStyleRequest = (id) => {
  return {
    url: "/content_writing_styles/" + id,
    method: "GET",
  };
};

export const createSaveContentWritingStyleRequest = (name, posts) => {
  return {
    url: "/content_writing_styles",
    method: "POST",
    data: {
      name,
      posts,
    },
  };
};

export const createDeleteContentWritingStyleRequest = (id) => {
  return {
    url: "/content_writing_styles/" + id,
    method: "DELETE",
  };
};

export const createUpdateContentWritingStyleRequest = (id, name, posts) => {
  return {
    url: "/content_writing_styles/" + id,
    method: "PUT",
    data: {
      name,
      posts,
    },
  };
};
